// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__anC6c","label":"SetPasswdForm_label__W-o6k"};